import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Session } from 'protractor';
import { lastValueFrom } from 'rxjs';
import { User } from 'src/app/core/models/user';
import { AccountService } from 'src/app/core/services/account.service';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import { UserService } from 'src/app/core/services/user.service';
import { environment } from 'src/environments/environment';

export interface UpdateStatusData {
    mandateId: string;
    status: string;
}

@Component({
    selector: 'app-payu-redirect',
    templateUrl: './payu-redirect.component.html',
    styleUrl: './payu-redirect.component.scss'
})
export class PayuRedirectComponent implements OnInit {
    private status: string = '';

    private txnId: string = '';

    public updateStatusData: UpdateStatusData = {
        mandateId: '',
        status: ''
    }

    constructor(private route: ActivatedRoute, private accountService: AccountService, private http: HttpClient, private userService: UserService, private router: Router, private spinner: NgxSpinnerService) {

    }

    public async ngOnInit() {
        this.spinner.show();

        if (environment.production) {
            this.migrateSessionToLocalStorage();
        }

        this.route.queryParamMap.subscribe(params => {
            this.txnId = params.get('txnid');
            this.status = params.get('status');
        });


        if (this.status === 'success') {
            if (environment.production) {
                this.migrateLocalToSessionStorage();
            }
            this.updateStatusData.mandateId = this.txnId;
            this.updateStatusData.status = 'accepted';
            try {
                await lastValueFrom(this.accountService.UpdateAutoPayMandateStatus(this.updateStatusData));
                await lastValueFrom(this.accountService.updateNACHApplicationStatus(this.txnId, 2));
                this.router.navigateByUrl("/assist-journey/payment-gateway?wasredirectedfromupi=true");
            } catch (error) {
                console.error('Error occurred:', error);
                this.spinner.hide();
                this.router.navigateByUrl("/assist-journey/session-expired");
            }
        }
        else {
            if (environment.production) {
                this.migrateLocalToSessionStorage();
            }
            this.updateStatusData.mandateId = this.txnId;
            this.updateStatusData.status = 'rejected';
            try {
                await lastValueFrom(this.accountService.UpdateAutoPayMandateStatus(this.updateStatusData));
                await lastValueFrom(this.accountService.updateNACHApplicationStatus(this.txnId, 2));
                this.router.navigateByUrl("/assist-journey/nach-mandate");
            } catch (error) {
                console.error('Error occurred:', error);
                this.spinner.hide();
                this.router.navigateByUrl("/assist-journey/session-expired");
            }
        }

    }

    public async PaymentUpdateEaseBuzz(payment_status: string, MerchantId: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.route.queryParams.subscribe((params: any) => {
                const baseUrl = environment.apiUrl + 'PaymentGateway/PaymentStatusReceiver';
                let obj = {
                    'ResponseId': MerchantId,
                    'payment_id': MerchantId,
                    'payment_link_status': payment_status,
                    'signature': "OK"
                };

                this.http.post(baseUrl, obj).subscribe(
                    response => {
                        if (response['data'] != null) {
                            this.spinner.hide();
                            if (response['data'].partnerCallbackUrl != null && response['data'].partnerCallbackUrl !== 'undefined' && response['data'].partnerCallbackUrl != '') {


                                /*** Redirect if DownPayment Payment Failed/Success for Sterling Holidays ***/
                                if (payment_status === 'unpaid') {
                                    if (environment.sterlingHolidaysConsolidator.includes(MemoryStorageService.getItem("consolidatorId"))) {
                                        const data = { partnerTransactionId: MemoryStorageService.getItem("partnerTransactionId"), status: "PaymentFailed" };
                                        this.userService.redirectWithPost(localStorage.getItem('partnercallback'), data);
                                        return;
                                    }
                                }


                                if (payment_status === 'paid') {
                                    if (environment.sterlingHolidaysConsolidator.includes(MemoryStorageService.getItem("consolidatorId"))) {
                                        const data = { partnerTransactionId: MemoryStorageService.getItem("partnerTransactionId"), status: "PaymentCompleted", mihuruTransactionId: MerchantId, amount: MemoryStorageService.getItem('loanAmount') };
                                        this.userService.redirectWithPost(localStorage.getItem('partnercallback'), data);
                                        return;
                                    }

                                }
                                /*******************/
                                window.location.replace("https://" + response['data'].partnerCallbackUrl);

                            } else {

                                if (payment_status === 'unpaid') {
                                    return this.router.navigateByUrl('/assist-journey/assist-underwrite').then(() => resolve());
                                }
                                else if (payment_status === 'paid') {
                                    return this.router.navigateByUrl('/assist-journey/assist-success').then(() => resolve());
                                }
                            }
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        });
    }

    private migrateSessionToLocalStorage() {
        for (const [key, value] of Object.entries(sessionStorage)) {
            localStorage.setItem(key, value);
        }

        const data = localStorage.getItem('user');
        const userData = JSON.parse(data);
        const user: User = {
            userName: userData['userName'],
            email: userData['email'],
            mobileNumber: userData['mobileNumber'],
            token: userData['token'],
            docs: [
                {
                    bankstatement: userData['bankstatement']
                }
            ],
            emiamount: Number(userData['emiamount']),
            collectionAmount: Number(userData['collectionAmount']),
            fullname: userData['fullname'],
            firstCollectionDate: userData['firstCollectionDate'],
            showFooter: true,
        };
        this.accountService.setCurrentUser(user);
    }

    private migrateLocalToSessionStorage() {
        for (const [key, value] of Object.entries(localStorage)) {
            sessionStorage.setItem(key, value);
        }
        localStorage.clear();
    }

}
